<template>
  <div class="infoData">
    <div class="go_back_common">
      <div class="go_back_title" @click="$router.replace('/mainData/operateLog')">
        <span class="go_back_icon" />
        <span class="go_back_txt">返回</span>
      </div>
      <div class="go_back_lines" />
    </div>
    <div class="logInfo_box">
      <div class="infobox_caption">基本信息</div>
      <el-row>
        <el-col :span="8">
          <el-row>
            <span class="infobox_label">用户:</span>
            <span class="infobox_value">{{ info.userName||'-' }}</span>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <span class="infobox_label">平台：</span>
            <span class="infobox_value">{{ info.platform ||'--' }}</span>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <span class="infobox_label">登录账号:</span>
            <span class="infobox_value">{{ info.loginAccount||'--' }}</span>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <span class="infobox_label">操作时间:</span>
            <span class="infobox_value">{{ info.createTime||'-' }}</span>
          </el-row>
        </el-col>
        <el-col :span="8">
          <el-row>
            <span class="infobox_label">事件：</span>
            <span class="infobox_value">{{ info.eventName||'-' }}</span>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <span class="infobox_label">模块名称：</span>
            <span class="infobox_value">{{ info.moduleName||'--' }}</span>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="logInfo_box">
      <div class="infobox_caption">操作环境</div>
      <el-row>
        <el-col :span="12">
          <el-row>
            <span class="infobox_label">IP地址：</span>
            <span class="infobox_value">{{ info.operateIp || '--' }}</span>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div class="logInfo_box">
      <div class="infobox_caption">操作内容</div>
      <div v-for="(item,index) in info.logContent" :key="index" class="f-flex">
        <div class="infobox_label" style="text-align: left;">{{ item.name }}：</div>
        <div v-if="item.logType==1" :span="16" class="infobox_value">{{ item.value }}</div>
        <div v-if="item.logType==2" :span="16" class="infobox_value">
          <template v-for="(it,idx) in item.imageList">
            <el-image
              :key="idx"
              style="width: 100px; height: 100px;margin-right: 5px"
              :src="it"
              :preview-src-list="[it]"
            />
          </template>
        </div>
        <div v-if="item.logType==4" :span="16" class="m_logmanage_value">
          <um-upload
            v-model="item.attachList"
            style="display: inline"
            disabled
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { logInfo } from '@/api/mainData/operateLog'

export default {
  name: 'OperateLogInfo',
  data() {
    const that = this
    return {
      logId: that.$route.query.logId,
      info: {},
      content: {}
    }
  },
  created() {
    this.getInfo()
  },
  mounted() {
    sessionStorage.setItem('searchFlag', true)
  },
  methods: {
    getInfo() {
      logInfo({ logId: this.$route.query.logId }).then(res => {
        this.info = res.data
      })
    }
  }
}
</script>

<style scoped>

</style>
